import FaqAuto from './faq-auto/FaqAuto';
import FaqManual from './faq-manual/FaqManual';
import React, { useEffect, useState } from 'react';
import { BackButton2 } from '../../../../common/BackButton2';
import { useNavigate } from 'react-router-dom';
import {
  deleteFaq,
  generateFAQFromDocuments,
  getFaqList,
  getListOfDocuments
} from '../../../../api/AccountSetup';
import ToastNotification from '../../../../common/ToastNotification';
import { HOSPITALITY_LIST, NEW_LIST, OTHER_LIST, RETAILER_LIST } from '../DATA';
import { useMenuContext } from '../../../../Contexts/MenuContext';
interface IntegrationProps {
  isSettings?: boolean;
}
const Faq = (props: IntegrationProps) => {
  const { isSettings } = props;
  const navigate = useNavigate();
  const { menuList } = useMenuContext();
  const companyUuid = sessionStorage.getItem('companyUuid');
  const businessType = sessionStorage.getItem('businessType');
  const subscriptionPlanDetail = sessionStorage.getItem('planDetail');

  const [disable, setDisable] = useState(false);
  const [isdisable, setIsDisable] = useState(false);
  const [documentList, setDocumentList] = useState<
    Array<{ type: string; name: string; uuid: string; faqErr: string | null }>
  >([]);
  const [isloading, setIsLoading] = useState(false);
  const [faqList, setFaqList] = useState<
    { uuid: string | null; faq: { question: string; answer: string }[] }[]
  >([]);
  const [blankFaqList, setBlankFaqList] = useState<any>([]);
  const [questionsList, setQuestionsList] = useState<
    Array<{ question: string; answer: string; uuid?: string | null }>
  >([]);
  const [subscriptionData, setSubscriptionData] = useState<any>(null);

  const stepsList =
    businessType === 'Retail'
      ? RETAILER_LIST
      : businessType === 'WordpressRetail' || businessType === 'OdooRetail' ? NEW_LIST
        : businessType === 'Hospitality' && menuList.includes('Services')
          ? HOSPITALITY_LIST
          : OTHER_LIST;
  const stepNumber = stepsList.filter((data) => data.step === 'FAQ')[0].id;
  const [allquestionsList, setAllQuestionsList] = useState<
    Array<{ question: string; answer: string; uuid?: string | null }>
  >([]);
  useEffect(() => {
    if (subscriptionPlanDetail) {
      setSubscriptionData(JSON.parse(subscriptionPlanDetail));
    }
  }, []);

  const handleGoBack = () => {
    businessType === 'Retail'
      ? navigate('/account-setup/create-profile')
      : businessType === 'Hospitality' && menuList.includes('Services')
        ? navigate('/account-setup/create-product')
        : navigate('/account-setup/create-menu');
  };
  const handleDeleteFaq = async (index: number, faqUUID: string) => {
    if (faqUUID) {
      setIsLoading(true);

      const resp = await deleteFaq(faqUUID, companyUuid ? companyUuid : '');
      if (resp.ok) {
        setIsLoading(false);
        fetchAllFaq();

        ToastNotification({
          message: 'Deleted Successfully',
          type: 'success'
        });
      } else {
        setIsLoading(false);
        ToastNotification({
          message: 'Something went wrong',
          type: 'error'
        });
      }
    } else {
      const updatedQuestions = questionsList.filter((_, i) => i !== index);
      setQuestionsList(updatedQuestions);
      if (faqList && faqList?.length > 0) {
        setFaqList((prevFaqList) => {
          let cumulativeIndex = 0;

          for (let i = 0; i < prevFaqList.length; i++) {
            const arrayLength = prevFaqList[i]?.faq?.length || 0;

            if (index >= cumulativeIndex && index < cumulativeIndex + arrayLength) {
              const localIndex = index - cumulativeIndex;

              const updatedFaqList = [...prevFaqList];
              updatedFaqList[i] = {
                ...updatedFaqList[i],
                faq: updatedFaqList[i]?.faq.filter((_, idx) => idx !== localIndex)
              };

              return updatedFaqList;
            }

            cumulativeIndex += arrayLength;
          }

          return prevFaqList;
        });
      }
    }
  };

  const fetchGeneratedFAQ = async () => {
    try {
      setDisable(true);
      const listOfUUID = documentList.map((info: any) => info.uuid);
      const payload = { uuids: listOfUUID };
      const res = await generateFAQFromDocuments(payload, companyUuid ? companyUuid : '');
      if (res.message === 'Successful') {
        if (res.payload.complete) {
          const generatedFAQList = res.payload.payload
            .filter((item: any) => item.faq.length > 0)
            .map((item: any) => ({
              ...item,
              faq: item.faq
            }));
          setDisable(false);
          setFaqList(generatedFAQList);
          setBlankFaqList(res.payload.payload.filter((item: any) => item.faq.length === 0));
          setQuestionsList([
            ...allquestionsList,
            ...generatedFAQList.flatMap((item: any) => item.faq)
          ]);
          if (generatedFAQList.length > 0) {
            ToastNotification({
              message: 'FAQ generated successfully',
              type: 'success'
            });
          }
        } else {
          setTimeout(() => {
            fetchGeneratedFAQ();
          }, 5000);
        }
      } else {
        ToastNotification({
          message: res.message,
          type: 'error'
        });
        setDisable(false);
        setFaqList([]);
        setBlankFaqList([]);
        setQuestionsList([...allquestionsList]);
      }
    } catch (errr) {
      setDisable(false);
    }
  };

  const showFaqErr = (id: string) => {
    const getIndex = blankFaqList?.findIndex((i: any) => i.uuid === id);
    return blankFaqList.length > 0 && getIndex !== -1 ? blankFaqList[getIndex].error : '';
  };

  const fetchAllDocuments = async () => {
    try {
      setIsLoading(true);
      const documentList = await getListOfDocuments(companyUuid ? companyUuid : '');
      const formattedDocumentList = documentList.payload.result.map((info) => ({
        ...info,
        faqErr: showFaqErr(info.uuid)
      }));
      setDocumentList(formattedDocumentList || []);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error('Error fetching FAQ list:', error);
      setDocumentList([]);
    }
  };

  const fetchAllFaq = async () => {
    try {
      setIsLoading(true);
      const faqList = await getFaqList(companyUuid ? companyUuid : '');
      setQuestionsList((prevQuestionsList) => {
        const newList = faqList.payload.list || [];
        const withoutId = prevQuestionsList.filter((item) => !item.uuid);
        return [...newList, ...withoutId];
      });
      setAllQuestionsList(faqList.payload.list || []);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error('Error fetching FAQ list:', error);
      setQuestionsList([]);
    }
  };

  useEffect(() => {
    fetchAllDocuments();
  }, [blankFaqList]);

  return (
    <div className="flex flex-col flex-1 bg-[#1E1E1E] rounded-lg lg:px-0 md:pt-3 lg:pt-6 p-2 overflow-y-auto">
      {!isSettings && (
        <h2 className="h-[31px] md:mb-[5px] lg:ml-9 ml-[4px] md:ml-1  text-[14px]   sm:leading-[26.86px] lg:text-base md:text-base font-normal">
          STEP {stepNumber}
        </h2>
      )}

      <div className="flex ml-[4px] md:ml-1">
        {!isSettings && (
          <div className="lg:mt-[-3px] md:mt-1 mt-[-2px] mr-1 sm:pt-[3px] lg:pt-0">
            <BackButton2 onClick={handleGoBack} />
          </div>
        )}

        <h1
          className={`h-[39px] ${isSettings ? 'ml-8' : 'lg:ml-0'} lg:mt-[1px] md:mt-[10px] mt-[-2px] text-[16px] sm:leading-[29.18px] md:text-base lg:text-base  font-medium`}
        >
          Frequently Asked Questions
        </h1>
      </div>

      <FaqAuto
        fetchGeneratedFAQ={fetchGeneratedFAQ}
        fetchAllDocuments={fetchAllDocuments}
        documentList={documentList}
        disable={disable}
        isLoading={isloading}
        setIsLoading={setIsLoading}
        setDocumentList={setDocumentList}
      />
      <FaqManual
        isLoading={isloading}
        faqList={faqList}
        questionsList={questionsList}
        setQuestionsList={setQuestionsList}
        disable={isdisable}
        setDisable={setIsDisable}
        fetchAllFaq={fetchAllFaq}
        handleDeleteFaq={handleDeleteFaq}
        setFaqList={setFaqList}
        isSettings={isSettings}
        allquestionsList={allquestionsList}
        fetchAllDocuments={fetchAllDocuments}
      />
    </div>
  );
};

export default Faq;
